// eslint-disable-next-line
export default [
    { name: 'JS', url: "https://js.techstart.dev/"},
    { name: 'REACT', url: "https://techstart-react.herokuapp.com/" },
]